<template>
	<div id="MAM_terminalList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="formInline.phone" placeholder="请输入移动代理商账号"></el-input></el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.agent_no" placeholder="请输入移动代理商编号"></el-input></el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.parent_phone" placeholder="请输入移动后直属代理商账号"></el-input></el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.aps_phone" placeholder="请输入移动后所属代理账号"></el-input></el-form-item>
				<el-form-item>
					<el-select :editable="false" size="medium" v-model="formInline.moved_status" filterable clearable style="width:100%"
						placeholder="请选择移动状态">
						<el-option label="待移线" value="1"></el-option>
						<el-option label="移线成功" value="2"></el-option>
						<el-option label="移线失败" value="3"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="移动发起开始日期"
                        end-placeholder="移动发起结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate2"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="移动结束开始日期"
                        end-placeholder="移动结束结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange2"
                    ></el-date-picker>
                </el-form-item>
                
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(formInline)">查询</el-button>
                    <el-button size="medium" type="primary"  style="font-size: 12px;"
                    	@click="setMoveClick()">设置移线</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading">
                <el-table-column header-align="center" align="center" fixed type="index" label="ID"
                min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="nickname" label="移动代理商昵称" min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="移动代理商账号" min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="移动代理商编号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="level" label="当前层级" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="bp_phone" label="直属上级代理账号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="bp_nickname" label="直属上级昵称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="ps_nickname" label="所属机构昵称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="ps_phone" label="所属机构账号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="ap_phone" label="移动后直属代理账号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="ap_nickname" label="移动后直属代理昵称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="aps_phone" label="移动后所属机构账号" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="aps_nickname" label="移动后所属机构昵称" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="moved_user_after_level" label="移动后层级" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="moved_start_time" label="移线发起时间" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="moved_end_time" label="移线结束时间" min-width="160"></el-table-column>
		
				<el-table-column header-align="center" align="center" prop="status_text" label="移线状态" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="moved_remark" label="备注" min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="160"></el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>
        
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "moveLineManage",
		data() {
			return {
				brandList: [],
				formInline: {
					agent_no: '', //代理商编码
					phone: '', //代理商账号
                    parent_phone:'', // 移动后直属代理商账号
                    aps_phone:'', // 移动后所属机构账号
                    moved_status:'' ,// 移线状态 移线状态 1待移线 2 移线成功 3移线失败
                    s_start_time:'', // 移动发起开始时间区间
                    s_end_time:'', //  移动发起结束时间区间
                    e_start_time:'',  // 移动结束开始时间区间
                    e_end_time:'', //  移动结束结束时间区间
                    group_name:'',
                    level_name:''
				},
				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
                rangeDate:[],
                rangeDate2:[],
			}
		},
		mounted() {
			this.getData()
		},
		components: {
			paginations,
		},
		methods: {
            pickerChange(DateArr) { //时间选择器
                this.formInline.s_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.e_start_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");

            },
            
            pickerChange2(DateArr) { //时间选择器
                this.formInline.s_end_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.e_end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            
            },
            
            
            setMoveClick(){
                this.$router.push({
                	path: '/setMoveLine'
                });
            },
			onSearch() { //搜索
				this.page.currentPage = 1;
				// 表单提交
				this.getData()
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData();
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData()
			},
			getData() {
                this.formInline.page = this.page.currentPage
                this.formInline.limit = this.page.pageSize
				this.$api.post("user_lane_change/userUserLaneChangePage", this.formInline, res => {
					let data = res.data;
					this.page.total = data.count; //总数
					this.transferList.list = res.data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>